import { IAuthContext } from '@src/assets/types';
import { createContext } from 'react';

const AuthContext = createContext<IAuthContext | null>(null);

export default AuthContext;
